/// <reference path="../../../../node_modules/@types/globalize/index.d.ts" />
/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../teva/slideorfade/slideorfade.ts" />
/// <reference path="../../../teva/infinitescroll/infinitescroll.ts" />
/// <reference path="../../common/resources/resources.ts" />
/// <reference path="../../common/modals/modals.ts" />

namespace OfficeGuy.Website {
    export class Settings {
        static LanguageChange_ShowModal(SelectedValue): void {
            if (SelectedValue == "he-IL")
                return;
            OfficeGuy.Modals.ShowMessageDialog(OfficeGuy.Resources.GetString("Website", "LanguageChange_Title"),
                OfficeGuy.Resources.GetString("Website", "LanguageChange_Message"));
        }

        static APIKey_Change(): boolean {
            OfficeGuy.Modals.ShowConfirmDialog({
                Title: "הפקת מפתח התחברות פרטי",
                Message: "האם ברצונך להפיק מפתח התחברות חדש?",
                ConfirmEvent: function () {
                    $("#Generate").val('Private');
                    OfficeGuy.Forms.SubmitForm();
                }
            });
            return false;
        }

        static APIPublicKey_Change(): boolean {
            OfficeGuy.Modals.ShowConfirmDialog({
                Title: "הפקת מפתח התחברות ציבורי",
                Message: "האם ברצונך להפיק מפתח התחברות חדש?",
                ConfirmEvent: function () {
                    $("#Generate").val('Public');
                    OfficeGuy.Forms.SubmitForm();
                }
            });
            return false;
        }

        static APIRemove(ID): boolean {
            OfficeGuy.Modals.ShowConfirmDialog({
                Title: 'מחיקת מפתח',
                Message: 'האם ברצונך למחוק את המפתח? לא ניתן לשחזר מפתח שנמחק.',
                ConfirmText: 'מחיקה',
                ConfirmEvent: function () {
                    $('#Revoke').val(ID);
                    OfficeGuy.Forms.SubmitForm();
                }
            });
            return false;
        }

        static InitApplicationSettingsPage() {
            $(".og-applications-settings div[og-settings-key]").each(function () {
                var $this = $(this);
                var Key = $this.attr("og-settings-key");
                
                var $Children = $(".og-applications-settings div[og-settings-parentkey=" + Key + "]");
                if ($Children.length == 0)
                    return;

                var $Checkbox = $this.find("input[type=checkbox]");
                if ($Checkbox.length == 0)
                    return;

                $Checkbox.on("change.og-applications-settings", function () {
                    Teva.SlideOrFade.Toggle($Children, $Checkbox.prop("checked"));
                });
                $Children.toggle($Checkbox.prop("checked"));
            });
        }

        static CompanyTypeChanged($Select) {
            var SelectBox = Teva.SelectBox.GetInstance($Select);
            if (SelectBox.SelectedValue == "-1") {
                for (var i = 0; i < SelectBox.SelectConvertedResults.length; i++) {
                    if (SelectBox.SelectConvertedResults[i].id == "-1")
                        SelectBox.SelectConvertedResults[i].cssClass = "hide";
                    else if (SelectBox.SelectConvertedResults[i].cssClass = "hide")
                        SelectBox.SelectConvertedResults[i].cssClass = "";
                }
                SelectBox.ClearValue();
                setTimeout(function () {
                    SelectBox.ShowResults();
                }, 100);
            }
        }

        static InitDeveloperLogsPagination() {
            Teva.InfiniteScroll.Enable({
                ResultsContainerSelector: ".og-developers-logs",
                ItemSelector: ".og-accordion",
                PaginationSelector: ".og-developers-logs-pagination",
                NextSelector: ".og-developers-logs-pagination",
            });
        }
    }
}